export const XES_TOUCH_DOMAIN = 'touch.xueersi.com'
export const XES_APP_DOMAIN = 'app.xueersi.com'
export const XES_HOME_DOMAIN = 'home.xueersi.com'
export const XES_ACCOUNT_DOMAIN = 'account.xueersi.com'
export const XES_LOGIN_DOMAIN = 'login.xueersi.com'
export const XES_API_DOMAIN = 'api.xueersi.com'
export const XES_TRADE_DOMAIN = 'trade.xueersi.com'
export const XES_OCENTER_DOMAIN = 'ocenter.xueersi.com'
export const XES_CARDCOUPON_DOMAIN = 'cardcoupon.xueersi.com'
export const XES_ACTIVITY_DOMAIN = 'activity.xueersi.com'
export const XES_REG_DOMAIN = 'reg.xueersi.com'
export const XES_BOOSTER_DOMAIN = 'booster.xueersi.com'
export const XES_EXAM_DOMAIN = 'exam.xueersi.com'
export const XES_LEGAO_DOMAIN = 'legao.xueersi.com'
export const XES_MALL_DOMAIN = 'mall.xueersi.com'
export const XES_CART_DOMAIN = 'cart.xueersi.com'
export const XES_ABILITY_DOMAIN = 'ability.xueersi.com'
export const XES_ADS_DOMAIN = 'ads.xueersi.com'
export const XES_EXAMINATION_DOMAIN = 'examination.xueersi.com'
export const XES_WEIXIN_DOMAIN = 'weixin.xueersi.com'
export const XES_GAOZHONG_DOMAIN = 'gaozhong.xueersi.com' // 商城在使用的域名（旧版）

//
export const XES_SUBJECT_DOMAIN = 'www.xiwang.com' // 新学科
export const XES_XES_DOMAIN = 'www.xueersi.com' // 学而思
export const XES_SUYANG_DOMAIN = 'www.xessuyang.com' // 素质
export const XES_VIPX_DOMAIN = 'www.vipx.com' // 高中 (new)

// 主域名
export const DOMAIN_PART_XUEERSI = '.xueersi.com'
export const DOMAIN_PART_XINXUEKE = '.xiwang.com'
export const DOMAIN_PART_SUYANG = '.xessuyang.com'
export const DOMAIN_PART_VIPX = '.vipx.com'



// WEBPACK FOOTER //
// ./node_modules/@xes/trade-toolkit/src/domain.js